/* generated using openapi-typescript-codegen -- do no edit */
/* istanbul ignore file */
/* tslint:disable */
/* eslint-disable */

import type { PermissionCollectionResource } from './PermissionCollectionResource'

export type OrganizationUserResource = {
    id: number
    firstname: string
    lastname: string
    username: string
    email: string
    primary: boolean
    permissions: PermissionCollectionResource
    tithely_permissions: Array<string>
    /**
     * Tithely user ID, if linked
     */
    tithely_id: string | null
    role_id: number
    role_name: string | null
    mfa_status: OrganizationUserResource.mfa_status | null
    email_verified: string | null
    last_active: string | null
}

export namespace OrganizationUserResource {
    export enum mfa_status {
        TOTP = 'totp',
        EMAIL = 'email'
    }
}
